<template>
  <div></div>
</template>

<script>
export default {
  auth: false,
  middleware: ['guest.middleware'],
};
</script>
